import React from 'react';
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../../images/mcmasterLogoWhiteMar.png';
import './NewUserCard.css';

// User authentication hook that connected to the backend user auth API
import useAdmin from '../../hooks/useAdmin.js'

const NewUserCard = () => {
    const navigate = useNavigate();
    const { addUser } = useAdmin();

    const [uname, setUname] = useState('');
    const [upass, setUpass] = useState('');
    const [upassConfirm, setUpassConfirm] = useState('');
    const [error, setError] = useState('');

    const handleAddUser = async (e) => {
        e.preventDefault();

        // Ensure passwords match
        if (upass !== upassConfirm) {
            setError("Passwords do not match");
            return;
        }

        // Check user entered username and password
        if (!uname || !upass) {
            setError("Username and password are required");
            return;
        }

        const result = await addUser(uname, upass);

        if (result.success) {
            console.log(result.success);
            console.log("good");
            navigate('/admin');
        } else {
            setError(result.message);
        }
    };

    return (
        <div className='login-card'>
            <div className='logo-container'>
                <img className='logo-login' src={Logo}/>
            </div>
            <div >
                {/* <form className='field-container' onSubmit={handleLogin}> */}
                <form className='field-container' onSubmit = {handleAddUser}>
                    <input 
                        className='input-field' 
                        placeholder='Username' 
                        type='text' 
                        value={uname}
                        onChange={(e) => setUname(e.target.value)}
                        required
                    />
                    <input 
                        className='input-field' 
                        placeholder='Password' 
                        type='password' 
                        value={upass}
                        onChange={(e) => setUpass(e.target.value)}
                        required
                    />
                    <input 
                        className='input-field' 
                        placeholder='Retype Password' 
                        type='password' 
                        value={upassConfirm}
                        onChange={(e) => setUpassConfirm(e.target.value)}
                        required
                    />
                    {error && <p style={{ color: 'red' }}>{error}</p>} {/* Add error reporting */}
                    <button className='login-button' type='submit'>Create User ➜</button>
                </form>
            </div>
        </div>
    );
};

export default NewUserCard;